<template>
    <div class="p-10 overflow-scroll">
        <hts-data-table
            :headers="companyHistoryDetail"
            :items="rowData" />
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  params: Object
})
const { params } = toRefs(props)
const companyHistoryDetailData: { [key: string]: any } = ref({})
const rowData: Array<Object> = []
onBeforeMount(() => {
  companyHistoryDetailData.value = params?.value?.data
})
watch(
  () => companyHistoryDetailData.value,
  () => {
    const oldData = companyHistoryDetailData.value.oldData
    const newData = companyHistoryDetailData.value.newData
    nextTick(() => {
      Object.keys(oldData).forEach((key: any) => {
        if (key === 'updatedAt' || key === 'deleted') {
          return null
        }
        rowData.push({
          dataName: checkNameData(key),
          oldData: oldData[key],
          newData: newData.$set[key]
        })
      })
    })
  }
)
const companyHistoryDetail = [
  {
    field: 'dataName',
    label: 'dataName',
    headerName: $t('labels.companyHistory.nameData'),
    sortable: true
  },
  {
    field: 'oldData',
    label: 'oldData',
    headerName: $t('labels.companyHistory.oldData'),
    sortable: true,
    valueGetter: (params: any) => {
      const oldDataValue = params.data.oldData
      if (typeof oldDataValue !== 'object') {
        return oldDataValue
      }
      return oldDataValue.$numberDecimal
    }
  },
  {
    field: 'newData',
    label: 'newData',
    headerName: $t('labels.companyHistory.newData'),
    sortable: true,
    valueGetter: (params: any) => {
      const newDataValue = params.data.newData
      if (typeof newDataValue !== 'object') {
        return newDataValue
      }
      return newDataValue.$numberDecimal
    }
  }
]
const checkNameData = (keyData: string) => {
  if (!keyData) {
    return false
  }
  if (keyData.includes('invoicingInformation') || keyData.includes('bankingInformation')) {
    const dotPosition = keyData.indexOf('.')
    if (!dotPosition) {
      return false
    }
    const fieldName = keyData.slice(0, dotPosition) === 'invoicingInformation' ? 'thông tin hóa đơn' : 'thông tin ngân hàng'
    const childrenFieldName: any = checkNameData(keyData.slice(dotPosition + 1))
    return `${childrenFieldName} của ${fieldName}`
  }
  switch (keyData) {
  case 'type':
    return $t('labels.historyCategory.type')
  case 'name':
    return $t('labels.historyCategory.name')
  case 'address':
    return $t('labels.historyCategory.address')
  case 'website':
    return $t('labels.historyCategory.website')
  case 'taxNumber':
    return $t('labels.historyCategory.taxNumber')
  case 'fax':
    return $t('labels.historyCategory.fax')
  case 'phone':
    return $t('labels.historyCategory.phone')
  case 'contactEmail':
    return $t('labels.historyCategory.contactEmail')
  case ' accountNumber':
    return $t('labels.historyCategory.accountNumber')
  case 'accountName':
    return $t('labels.historyCategory.accountName')
  case 'swiftCode':
    return $t('labels.historyCategory.swiftCode')
  case 'bankingName':
    return $t('labels.historyCategory.bankingName')
  case 'bankingAccountNumber':
    return $t('labels.historyCategory.bankingAccountNumber')
  case 'bankingBranch':
    return $t('labels.historyCategory.bankingBranch')
  case 'accountHolderName':
    return $t('labels.historyCategory.accountHolderName')
  case 'description':
    return $t('labels.historyCategory.description')
  case 'group':
    return $t('labels.historyCategory.group')
  case 'status':
    return $t('labels.historyCategory.status')
  case 'toKm':
    return $t('labels.historyCategory.toKm')
  case 'speed':
    return $t('labels.historyCategory.speed')
  case 'salaryByStage':
    return $t('labels.historyCategory.salaryByStage')
  case 'salaryByKm':
    return $t('labels.historyCategory.salaryByKm')
  case 'speedAssumption':
    return $t('labels.historyCategory.speedAssumption')
  default:
    break
  }
}
</script>
